<template>
  <modal
    title="Exchange Rate"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="input-wrapper my-2">
      <label for="bussiness" class="">Outlets</label>
      <el-select multiple v-model="outlets"  placeholder="--Select --">
          <el-option
          label="All Outlets"
          value="outlets"
          >
          </el-option>
      </el-select>
    </div>
    <div class="input-wrapper my-2">
      <label for="bank" class="">Base Currency</label>
      <input
        type="text"
        id="bank"
        class="input"
      />
    </div>
    <div class="input-wrapper my-2">
      <label for="acct_no" class="">Currency</label>
      <input
        type="text"
        id="acct_no"
        class="input"
      />
    </div>
    <div class="input-wrapper my-2">
      <label for="acct_name" class="">Exchange Rate</label>
      <input
        type="text"
        id="acct_name"
        class="input"
      />
    </div>

    <div class="p-2 bg-gray-600 text-center text-primary-yellow font-bold">
      1 yen = 5 NGB
    </div>

    <hr/>

    <div class="button-wrapper mt-5">
      <primary-button buttonText="Save"/>
      <p class="cursor-pointer pt-2 pr-3 mb-0" @click="closeModal">Close</p>
    </div>
  </modal>
</template>

<script>
export default {
  props: ["showModal"],
  data() {
    return {
     
    };
  },
  methods:{
    closeModal() {
      this.$emit("close-modal");
    }
  }
};
</script>
